import { PhonePrefixesVm } from '../api/model/phonePrefixesVm';

export type PhonePrefixState = {
  indicator: PhonePrefixesVm | null;
  phone: string;
  phone_consent: boolean;
  indicatorString: string;
};

export const initialPhonePrefixState: PhonePrefixState = {
  indicator: null,
  phone: '',
  phone_consent: false,
  indicatorString: '',
};
